import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuickFeed from './components/QuickFeed';
import PackIndex from './components/PackIndex';
import BigPack from './components/BigPack';
import HistoryTimeline from './components/HistoryTimeline';
import Guide from './components/Guide';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <div className="mx-auto my-12 h-px w-full max-w-7xl bg-background-200 md:my-16"></div>
        <QuickFeed />
        <div className="mx-auto my-12 h-px w-full max-w-7xl bg-background-200 md:my-16"></div>
        <PackIndex />
        <BigPack />
        <HistoryTimeline />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}